// --------------------------------------------------------------------------
// Membership Renewal Overseas postcode
//     - Update postcode if empty (as it would be from the lookup table for non-uk renewals) to non empty value to pass to Authorize.net
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var context = options.context;
    var postcodeHidden = context.find('input[name="x_zip"]');

    function init() {
        if (!postcodeHidden.val()) {
            postcodeHidden.val('XX');
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/membership-renewal-overseas-postcode.js
// module id = 483
// module chunks = 0